import { render, staticRenderFns } from "./personCategoryReduction.vue?vue&type=template&id=26019500&scoped=true"
import script from "./personCategoryReduction.vue?vue&type=script&lang=js"
export * from "./personCategoryReduction.vue?vue&type=script&lang=js"
import style0 from "./personCategoryReduction.vue?vue&type=style&index=0&id=26019500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26019500",
  null
  
)

export default component.exports